module.exports = __webpack_public_path__ + "static/media/ssa.0b8c1f99.png";